import { Documents } from "../Documents/documents";
import { ModulesManagerService } from "../Module/modules-manager.service";

export class Cgu {
    private id: number=0;
    private deprecated: boolean=false;
    private createdDate: number=0;
   
    constructor(private manager: ModulesManagerService, Data: any = null) {
        if (Data != null) {
            this.Hydrate(Data)
        }
        this.manager.GetModuleData("Documents",0, "Cgu", this.Id)
    }


    async Hydrate(Data, UpdateAnnex = false) {
        // hydrate les setter 
        for (const [propertie, values] of Object.entries(Data))
            this[this.manager.Tool.minimilizeFirstChar(propertie)] = values

    }

    get Documents(): Array<Documents> {
        return (this.manager.GetListModuleData("Documents", "Cgu", this.Id) as Array<Documents>).sort((a: Documents, b: Documents) => parseInt(a.FileName.replace("cgu-","").replace(".png","")) - parseInt(b.FileName.replace("cgu-","").replace(".png","")))
    }

    get Id(){
        return this.id
    }

    get CreatedDate() { 
        return (new Date(this.createdDate))["getFromFormat"](this.manager.Trad.Parse("STR_FULLDATE_DATETIME_PICKER"))
    }

    get Deprecated(){
        return this.deprecated
    }


}
